import React, {Component} from 'react'
import PropTypes from "prop-types"
import {addSkuSizeV2, deleteSkuSize, updateSkuSize} from "../../../../services/api/apiSku"
import {message} from "antd"
import TableRow from './TableRow'
import PubSub from 'pubsub-js'

class TableBody extends Component {
    state = {
        _sizes: [],
        editingItem: -1,
        loadingItem: -1,
        loadingDelete: false,
        errorDelete: '',
        pasteItems: [],
        isPasteCol: false,
        pasteInColumn: '',
        isPasteRow: false,
        pastingItem: -1,
    }

    componentDidMount() {
        const propSizes = Object.assign([], this.props.sizes)
        this.setState({
            _sizes: propSizes,
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.sizes.length !== prevProps.sizes.length) {
            const _size = Object.assign([], this.props.sizes)
            this.setState({
                _sizes: _size,
            })
        }
    }

    _handleAddSize = () => {
        const {_sizes} = this.state
        const newItem = {
            sku: "",
            width: 0,
            height: 0,
            length: 0,
            weight: 0,
            base_cost: 0,
            weight_by_v: "",
            created_at: "",
            type: "add",
        }
        _sizes.push(newItem)

        this.setState({
            _sizes: _sizes
        })
    }

    _actionAddSize = async (index) => {
        const {skuID, onGetSizes, objectType, objectName} = this.props
        const {_sizes} = this.state

        this.setState({
            loadingItem: index,
        })

        try {
            const newItem = _sizes[index]
            const payload = {
                sku: newItem.sku,
                dimension: {
                    width: newItem.width,
                    height: newItem.height,
                    length: newItem.length,
                    weight: newItem.weight,
                    additional_weight: newItem.additional_weight
                },
                base_cost: newItem.base_cost !== '' ? parseFloat(newItem.base_cost) : 0,
                weight_by_v: newItem.weight_by_v,
                // shipping_carrier: _sizes[0].shipping_carrier
            }

            const {data: respon} = await addSkuSizeV2(skuID, objectType, objectName, payload)
            const {success, message: errorAdd} = respon

            if (!success) return this.setState({
                loadingItem: -1,
                editingItem: -1
            }, () => {
                message.error(errorAdd)
            })

            this.setState({
                loadingItem: -1
            }, () => {
                message.success('Thêm mới size thành công!')
                onGetSizes()
                PubSub.publish('GET_HISTORY')
                PubSub.publish('GET_LIST_TAB')
            })
        } catch (e) {
            this.setState({
                loadingItem: -1
            }, () => {
                message.error(e.message)
            })
        }
    }

    _actionUpdateSize = async (index) => {
        const {skuID, onGetSizes, objectType, objectName} = this.props
        const {_sizes} = this.state

        this.setState({
            loadingItem: index,
        })

        try {
            const newItem = _sizes[index]
            const payload = {
                sku: newItem.sku,
                dimension: {
                    width: newItem.width,
                    height: newItem.height,
                    length: newItem.length,
                    weight: newItem.weight,
                    additional_weight: newItem.additional_weight
                },
                base_cost: newItem.base_cost !== '' ? parseFloat(newItem.base_cost) : 0,
                weight_by_v: newItem.weight_by_v !== '' ? parseFloat(newItem.weight_by_v) : 0,
                // shipping_carrier: _sizes[0].shipping_carrier
                optimization: {
                    type: objectType,
                    name: objectName
                }
            }

            const {data: respon} = await updateSkuSize(skuID, newItem._id, payload)
            const {success, message: errorUpdate} = respon

            if (!success) return this.setState({
                loadingItem: -1
            }, () => {
                message.error(errorUpdate)
            })

            this.setState({
                loadingItem: -1,
                editingItem: -1,
                pasteItems: [],
                isPasteCol: false,
                pasteInColumn: '',
                isPasteRow: false,
                pastingItem: -1,
            }, () => {
                message.success('Cập nhật size thành công!')
                onGetSizes()
                PubSub.publish('GET_HISTORY')
            })
        } catch (e) {
            this.setState({
                loadingItem: -1
            }, () => {
                message.error(e.message)
            })
        }
    }

    _actionDeleteSize = async (index) => {
        const {_sizes} = this.state
        const {skuID, onGetSizes} = this.props

        this.setState({
            loadingDelete: true,
            errorDelete: ''
        })

        try {
            const newItem = _sizes[index]
            if (newItem.type === '') {
                const {data: respon} = await deleteSkuSize(skuID, newItem._id)
                const {success, message: errorDelete} = respon

                if (!success) return this.setState({
                    loadingDelete: false,
                    errorDelete: errorDelete
                })

                this.setState({
                    loadingDelete: false,
                }, () => {
                    message.success('Xóa size thành công!')
                    onGetSizes()
                    PubSub.publish('GET_HISTORY')
                    PubSub.publish('GET_LIST_TAB')
                })
            } else {
                this.setState({
                    loadingDelete: false,
                }, () => {
                    message.success('Xóa size thành công!')
                    onGetSizes()
                    PubSub.publish('GET_HISTORY')
                    PubSub.publish('GET_LIST_TAB')
                })
            }
        } catch (e) {
            this.setState({
                loadingDelete: false,
                errorDelete: e.message
            })
        }
    }

    _handleChangeSizes = (item, index) => {
        const {_sizes} = this.state

        const newSizes = _sizes.map((_item, _index) => {
            if (_index === index) return item
            return _item
        })

        this.setState({
            _sizes: newSizes,
            editingItem: index
        })
    }

    _handlePasteSizes = (e, field, sizeIndex) => {
        const {isFFMView} = this.props
        const {_sizes} = this.state
        const copyText = e.clipboardData.getData("Text")
        
        let dimensionField= []
        if(isFFMView){
            dimensionField= ["sku", "height", "length", "width", "weight", "additional_weight", "base_cost"]
        }else{
            dimensionField= ["sku", "height", "length", "width", "weight", "additional_weight"]
        }
        let count = 0
        
        const pasteIndex = []
        let newSizes = []

        if(/[\r?\n]+/.test(copyText)){
            const parseTextColumn = copyText.split(/[\r?\n]+/)
            newSizes = _sizes.map((_item, _index) => {
                if (_index < sizeIndex || count >= parseTextColumn.length) return _item
                
                if(dimensionField.includes(field)){
                    pasteIndex.push(_index)
                    if(field === 'sku'){
                        return {
                            ..._item,
                            [field]: parseTextColumn[count++]
                        }
                    }else{
                        return {
                            ..._item,
                            [field]: parseFloat(parseTextColumn[count++])
                        }
                    }
                }
            })

            this.setState({
                _sizes: newSizes,
                pasteItems: pasteIndex,
                isPasteCol: true,
                pasteInColumn: field,
                isPasteRow: false,
                pastingItem: -1
            })
        }else if(/[\t]*/.test(copyText)){
            const parseTextRow = copyText.split(/[\t]+/)
            newSizes = _sizes.map((_item, _index) => {
                if (_index !== sizeIndex) return _item
                
                if(dimensionField.includes(field)){
                    pasteIndex.push(_index)

                    const fieldPosition = dimensionField.indexOf(field)
                    const dimensionFieldPaste = dimensionField.slice(fieldPosition)
                    let pasteTextRowUse = []
                    let dimensionFieldUse = []
                    if(dimensionFieldPaste.length < parseTextRow.length){
                        pasteTextRowUse = parseTextRow.slice(0, dimensionFieldPaste.length)
                        dimensionFieldUse = dimensionFieldPaste
                    }else if(dimensionFieldPaste.length > parseTextRow.length){
                        pasteTextRowUse = parseTextRow
                        dimensionFieldUse = dimensionFieldPaste.slice(0, parseTextRow.length)
                    }else{
                        pasteTextRowUse = parseTextRow
                        dimensionFieldUse = dimensionFieldPaste
                    }

                    const newItem = Object.fromEntries(dimensionFieldUse.map((key, index) => {
                        if(key === 'sku'){
                            return [key, pasteTextRowUse[index]]
                        }else{
                            return [key, parseFloat(pasteTextRowUse[index])]
                        }
                    }))

                    return {
                        ..._item,
                        ...newItem
                    }
                }
            })

            this.setState({
                _sizes: newSizes,
                pasteItems: pasteIndex,
                isPasteCol: false,
                pasteInColumn: field,
                isPasteRow: true,
                pastingItem: sizeIndex
            })
        }
    }

    _actionSavePasteColumn = () => {
        const {pasteItems} = this.state

        if(pasteItems && pasteItems.length > 0){
            pasteItems.map(item => this._actionUpdateSize(item))
        }
    }

    render() {
        const {isFFMView} = this.props
        const {_sizes, loadingItem, loadingDelete, errorDelete, editingItem, isPasteCol, pasteInColumn, isPasteRow, pastingItem} = this.state

        return <tbody>
            {
                _sizes.map((item, index) => {
                    return (
                        <TableRow
                            isFFMView={isFFMView} key={index} item={item} index={index} editingItem={editingItem}
                            loadingDelete={loadingDelete} errorDelete={errorDelete} loadingItem={loadingItem}
                            onChangeSizes={this._handleChangeSizes} onUpdateSize={this._actionUpdateSize}
                            onAddSize={this._actionAddSize} onDeleteSizes={this._actionDeleteSize}
                            onPasteSizes={this._handlePasteSizes} isPasteRow={isPasteRow} pastingItem={pastingItem}
                        />
                    )
                })
            }
            <tr>
                {/* <td colSpan={isFFMView ? 9 : 8}>
                <span className="cursor-pointer" onClick={this._handleAddSize}><i className="icon-floppy-disk mr-1 text-primary"/></span>
            </td> */}
                <td>
                    {
                        isPasteCol && pasteInColumn === 'sku' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'height' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'length' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'width' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none"></td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'weight' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'additional_weight' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="border-left-none"></td>
                <td className="border-left-none">
                    {
                        isPasteCol && pasteInColumn === 'base_cost' && <span className="cursor-pointer" onClick={this._actionSavePasteColumn}><i className="icon-floppy-disk mr-1 text-primary" /></span>
                    }
                </td>
                <td className="text-center">
                    <span className="cursor-pointer" onClick={this._handleAddSize}><i
                        className="icon-plus-circle2 text-success" /></span>
                </td>
            </tr>
        </tbody>
    }
}

TableBody.propTypes = {
    skuID: PropTypes.string.isRequired,
    sizes: PropTypes.array.isRequired,
    onGetSizes: PropTypes.func.isRequired,
}

export default TableBody
